import React, {useEffect, useState} from 'react'
import {FaChevronLeft, FaChevronRight} from 'react-icons/fa'
import NewSidebarMenu from './NewSidebarMenu'
import DemoVideosSidebarButton from './DemoVideosSidebarButton'
import {useReduxAuth} from '../../../../app/modules/auth'
import {USER_ROLES} from '../../../../app/constants/StatusConstants'

interface NewSidebarProps {
  // controlled when provided, otherwise component self-manages
  collapsed?: boolean
  onToggle?: (next?: boolean) => void
  appName: string
}
const newLogoRounded = '/media/logos/candi_logo_rounded.png'; 
const newLogo = '/media/logos/candi_logo.png';

const NewSidebar: React.FC<NewSidebarProps> = ({collapsed: collapsedProp, onToggle, appName}) => {
  const {currentUser} = useReduxAuth()
  const [internalCollapsed, setInternalCollapsed] = useState<boolean>(Boolean(collapsedProp ?? false))

  // keep internal state in sync when parent controls collapsed
  useEffect(() => {
    if (typeof collapsedProp === 'boolean') {
      setInternalCollapsed(collapsedProp)
    }
  }, [collapsedProp])

  // Auto-collapse on small screens only when uncontrolled
  useEffect(() => {
    if (typeof collapsedProp === 'boolean') return
    if (typeof window === 'undefined') return

    const mq = window.matchMedia('(max-width: 767px)')
    setInternalCollapsed(mq.matches)

    const listener = (e: MediaQueryListEvent | MediaQueryList) => {
      const matches = (e as MediaQueryListEvent).matches ?? (e as MediaQueryList).matches
      setInternalCollapsed(Boolean(matches))
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', listener as EventListener)
    } else {
      // legacy fallback
      // @ts-ignore
      mq.addListener(listener)
    }

    return () => {
      if (typeof mq.removeEventListener === 'function') {
        mq.removeEventListener('change', listener as EventListener)
      } else {
        // @ts-ignore
        mq.removeListener(listener)
      }
    }
  }, [collapsedProp])

  const effectiveCollapsed = typeof collapsedProp === 'boolean' ? collapsedProp : internalCollapsed

  const handleToggle = () => {
    if (typeof onToggle === 'function') {
      onToggle(typeof collapsedProp === 'boolean' ? !collapsedProp : !internalCollapsed)
    } else {
      setInternalCollapsed((s) => !s)
    }
  }

  return (
    <div
      className={`bg-white d-flex flex-column position-relative sidebar ${
        effectiveCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'
      }`}
    >
      {/* Header Section */}
      <div
        className={`d-flex ${
          effectiveCollapsed
            ? 'flex-column align-items-center pt-4 gap-3'
            : 'justify-content-between align-items-center p-4'
        }`}
      >
        {/* Logo */}
      {effectiveCollapsed ?
            <div>
              <img
                src={newLogoRounded}
                alt='Logo'
        className={`img-style ${effectiveCollapsed ? 'img-collapsed' : 'img-expanded'}`}
              />
            </div>
            : 
            <div className='d-flex align-items-center gap-2'>
              <img
                src={newLogo}
                alt='Logo'
        className={`img-style ${effectiveCollapsed ? 'img-collapsed' : 'img-expanded'}`}
              />
                {/* <h1 className='fs-5 fw-bold mb-0 text-primary'>{appName}</h1> */}
            </div>
          }


        {/* Collapse Toggle */}
        <button
          className='btn btn-link p-1 text-secondary min-width'
          onClick={handleToggle}
          aria-label={effectiveCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {effectiveCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
      </div>

      {/* Menu */}

      <div className='flex-grow-1 overflow-auto d-flex flex-column justify-content-start'>
        <NewSidebarMenu collapsed={effectiveCollapsed} />
      </div>

      {/* Demo Videos button at the bottom */}
      {currentUser?.role_id !== USER_ROLES.BILLING_PERSONNEL && (
        <DemoVideosSidebarButton collapsed={effectiveCollapsed} />
      )}


      {/* Tooltip styles when collapsed */}
      {/* {collapsed && (
        <style>
          {`.menu-item:hover::after {
              content: attr(data-title);
              position: absolute;
              left: 100%;
              top: 50%;
              transform: translateY(-50%);
              background: #1E1E1E;
              color: white;
              padding: 6px 12px;
              border-radius: 4px;
              font-size: 14px;
              white-space: nowrap;
              margin-left: 12px;
              pointer-events: none;
              z-index: 1000;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }`}
        </style>
      )} */}
      {/* <AutoImageUploader onChange={(url) => console.log('Uploaded URL:', url)} /> */}
    </div>
  )
}

export default NewSidebar
